const formEle = document.querySelector('[data-validation-required]');
 
if (!formEle) return;

// form inputs
const emailInput = formEle?.querySelector('#email');
const passInput = formEle?.querySelector('[type="password"]');
const confirmPassInput = formEle?.querySelector('#password_confirmation');
const nameInput = formEle?.querySelector('#first_name');
const surnameInput = formEle?.querySelector('#last_name');
const phoneInput = formEle?.querySelector('#tel');
const agreementInput = formEle?.querySelector('#agreement');
const contactNameInput = formEle?.querySelector('#contact_name');
const contactEmailInput = formEle?.querySelector('#contact_email');
const contactBodyText = formEle?.querySelector('#contact_body');
const zipCodeInput = formEle?.querySelector('#zip_code');
let forgotPassEmailInput;

// form buttons 
const loginButton = formEle?.querySelector('#submit-login');
const registerButton = formEle?.querySelector('#submit-register');
const contactButton = formEle?.querySelector('#submit-contact');
const resetPassButton = formEle?.querySelector('#submit-reset-password');
const passEyeButtons = formEle?.querySelectorAll('.password-icon');

const showForgotPassButton = formEle?.querySelector('[data-toggle-forgot-password]');

function isFieldEmpty(element) {
  return element.value.trim() === '';
}

function isTrue(element) {
  return element.checked;
}

function isPassword(element) {
  return element.type === 'password';
}

function isEmail(element) {
  return element.type === 'email';
}

function isPhone(element) {
  return element.type === 'tel';
}

function isEmailValid(element) {
  if (element.type !== 'email') return;
  let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return element.value.match(regex);
}

// -------------------------
//  UI helpers
// -------------------------
const $ = (selector, ctx = document) => ctx.querySelector(selector);
const $$ = (selector, ctx = document) => [...ctx.querySelectorAll(selector)];

function validationIcon(input, state = 'valid') {
  const wrapper = input.closest('[data-auth-input]');
  if (!wrapper) return;

  const validIcon   = $('.input-icon-success', wrapper);
  const invalidIcon = $('.input-icon-invalid', wrapper);

  const show = (icon, shouldShow) => icon && icon.classList.toggle('hidden', !shouldShow);

  switch (state) {
    case 'hidden':
      show(validIcon, false);
      show(invalidIcon, false);
      break;
    case 'invalid':
      show(validIcon, false);
      show(invalidIcon, true);
      break;
    default: // valid
      show(validIcon, true);
      show(invalidIcon, false);
  }
}

function isPasswordValid(element) {
  // Allows letters, numbers, and special characters: !@#$%^&*()_+{}[]:;<>,.?~\-=
  const regex = /^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\-=€]{8,}$/;
  return regex.test(element.value);
}

function isPhoneValid(element) {
  const regex = /^(\+45\s?)?(\d{2}\s?\d{2}\s?\d{2}\s?\d{2})$/;
  return regex.test(element.value);
}

function isZipValid(element) {
  const regex = /^\d{4}$/;
  return regex.test(element.value);
}

function isPasswordMatching() {
  const pwd  = $('#password');
  const pwd2 = $('#password_confirmation');
  return !!pwd && !!pwd2 && pwd.value === pwd2.value;
}

function makeErrorField(input, inputError, isError, inputError2, triggerSecondError = false) {
  if (isError) {
    input.classList.add('shadow-error', 'shadow-[0_2px_0_0]');
    inputError.classList.add('max-h-10');
    inputError.classList.remove('max-h-0');
  } else {
    input.classList.remove('shadow-error', 'shadow-[0_2px_0_0]');
    inputError.classList.remove('max-h-10');
    inputError.classList.add('max-h-0');
  }
  if (inputError2) {
    if (triggerSecondError) {
      inputError2.classList.add('max-h-10');
      inputError2.classList.remove('max-h-0');
    } else {
      inputError2.classList.remove('max-h-10');
      inputError2.classList.add('max-h-0');
    }
  }
}

// -------------------------
//  Field handler
// -------------------------
function handleInputError() {
  const input         = this;
  const [err1, err2]  = $$('[data-error-text]', input.closest('[data-auth-input]'));
  const empty         = isFieldEmpty(input);

  // Quick reactions to empty fields
  if (empty) {
    validationIcon(input, 'hidden');
    const showErr1 = true;
    makeErrorField(input, err1, showErr1);
    return;
  }

  // ----------------------
  // Password logic
  // ----------------------
  if (isPassword(input)) {
    const valid    = isPasswordValid(input);
    const matching = isPasswordMatching();

    // 1. invalid password, not matching (first keystrokes)
    if (!valid && !matching) {
      const showErr1 = true;
      makeErrorField(input, err1, showErr1);
      return;
    }

    // 2. invalid password format, but the two fields currently match
    if (!valid && matching) {
      const showErr1 = true;
      const showErr2 = false;
      makeErrorField(input, err1, showErr1, err2, showErr2);
      return;
    }

    // 3. valid format, but the two passwords differ
    if (valid && !matching) {
      let showErr1 = false;
      let showErr2 = true;
      if (!err2) showErr1 = true;
      makeErrorField(input, err1, showErr1, err2, showErr2);
      return;
    }

    // 4. valid and matching
    const otherPwd = $('input[type="password"]:not(#' + input.id + ')');
    if (otherPwd) {
      const [oErr1, oErr2] = $$('[data-error-text]', otherPwd.closest('[data-auth-input]'));
      const showErr1 = false;
      const showErr2 = false;
      makeErrorField(otherPwd, oErr1, showErr1, oErr2, showErr2);
    }
    const showErr1 = false;
    makeErrorField(input, err1, showErr1);
    return;
  }

  // ----------------------
  // Email / Phone / ZIP logic
  // ----------------------
  const invalidEmail = isEmail(input) && !isEmailValid(input);
  const invalidPhone = isPhone(input) && !isPhoneValid(input);
  const invalidZip   = input.id === 'zip_code' && !isZipValid(input);

  if (invalidEmail || invalidPhone || invalidZip) {
    const showErr1 = true;
    makeErrorField(input, err1, showErr1);
    validationIcon(input, 'invalid');
    return;
  }

  // ----------------------
  // Otherwise: field is valid
  // ----------------------
  const showErr1 = false;
  makeErrorField(input, err1, showErr1);
  validationIcon(input, 'valid');
}

function handleSubmitButton(button) {
  if (!button) return;

  let allInputsFilled;

  if (button.id === 'submit-forgot-password') {
    allInputsFilled = isEmailValid(forgotPassEmailInput);
  } else if (registerButton) {
    allInputsFilled = isEmailValid(emailInput) && !isFieldEmpty(nameInput) && !isFieldEmpty(surnameInput) && isPhoneValid(phoneInput) && isPasswordValid(passInput) && isTrue(agreementInput);
  } else if (loginButton) {
    allInputsFilled = passInput ? !isFieldEmpty(emailInput) && !isFieldEmpty(passInput) : !isFieldEmpty(emailInput);
  } else if (contactButton) {
    allInputsFilled = !isFieldEmpty(contactNameInput) && isEmailValid(contactEmailInput) && !isFieldEmpty(contactBodyText);
  } else if (resetPassButton) {
    allInputsFilled = !isFieldEmpty(confirmPassInput) && !isFieldEmpty(passInput);
  } else {
    return;
  }

  if (allInputsFilled) {
    button.removeAttribute('disabled');
  } else {
    button.setAttribute('disabled', 'disabled');
  }
}



function validateForgotPass() {
  const forgotPassForm = document.getElementById('recover-password-form');
  const forgotPasswordButton = forgotPassForm?.querySelector('#submit-forgot-password');
  forgotPassEmailInput = forgotPassForm?.querySelector('#customer_email');

  // Event listeners for enabling/disabling forgotPasswordForm
  handleSubmitButton(forgotPasswordButton);
  window.addEventListener('input', () => handleSubmitButton(forgotPasswordButton));

  // Input error event listeners
  const inputs = [forgotPassEmailInput];
  if (forgotPassEmailInput?.value) handleInputError.call(forgotPassEmailInput);
  inputs.forEach((input) => input?.addEventListener('blur', handleInputError));
}

function showPasswordIcon() {
  const passIcon = document.querySelector('.password-icon');
  const passInput = document.getElementById('password');

  if (!passIcon || !passInput) return;
  const isPasswordEmpty = isFieldEmpty(passInput);

  if (isPasswordEmpty) {
    passIcon.classList.add('hidden');
  } else {
    passIcon.classList.remove('hidden');
  }
}

function showPassword() {
  const passButton = this;
  const passInput = passButton.closest('[data-auth-input]')?.querySelector('[name*="password"]');
  if (passInput) passInput.type = 'text';
}

function hidePassword() {
  const passButton = this;
  const passInput = passButton.closest('[data-auth-input]')?.querySelector('[name*="password"]');
  if (passInput) passInput.type = 'password';
}

// Event listeners for enabling/disabling loginForm
if (loginButton) {
  window.addEventListener('load', () => {
    handleSubmitButton(loginButton);
  });

  emailInput?.addEventListener('input', () => {
    handleSubmitButton(loginButton);
  });

  passInput?.addEventListener('input', () => {
    handleSubmitButton(loginButton);
  });
}

// Event listeners for enabling/disabling registerForm
if (registerButton && emailInput && nameInput && surnameInput && phoneInput && passInput && agreementInput) {
  const registerInputs = [emailInput, nameInput, surnameInput, phoneInput, passInput, agreementInput];

  window.addEventListener('load', () => {
    handleSubmitButton(registerButton);
  });

  registerInputs.forEach((input) => {
    input.addEventListener('input', () => {
      handleSubmitButton(registerButton);
    });
  });
}

// Event listeners for enabling/disabling contactForm
if (contactButton) {
  window.addEventListener('load', () => handleSubmitButton(contactButton));
  contactNameInput?.addEventListener('input', () => {
    handleSubmitButton(contactButton);
  });
  contactEmailInput?.addEventListener('input', () => {
    handleSubmitButton(contactButton);
  });
  contactBodyText?.addEventListener('input', () => {
    handleSubmitButton(contactButton);
  });
}

// Event listeners for enabling/disabling resetPasswordForm
if (resetPassButton) {
  window.addEventListener('load', () => handleSubmitButton(resetPassButton));
  passInput?.addEventListener('input', () => handleSubmitButton(resetPassButton));
  confirmPassInput?.addEventListener('input', () => handleSubmitButton(resetPassButton));
}

// Event listeners for enabling/disabling forgotPasswordForm
showForgotPassButton?.addEventListener('click', validateForgotPass);

// Password icon event listeners
passEyeButtons?.forEach((passButton) => passButton.addEventListener('mousedown', showPassword));
passEyeButtons?.forEach((passButton) => passButton.addEventListener('mouseup', hidePassword));
passEyeButtons?.forEach((passButton) => passButton.addEventListener('touchstart', showPassword));
passEyeButtons?.forEach((passButton) => passButton.addEventListener('touchend', hidePassword));
passInput?.addEventListener('input', showPasswordIcon);

// Input error event listeners
if (registerButton) {
  const inputs = [emailInput, nameInput, surnameInput, phoneInput, passInput, confirmPassInput, agreementInput, zipCodeInput];
  inputs.forEach((input) => input?.addEventListener('blur', handleInputError));
}

if (contactButton) {
  const inputs = [contactNameInput, contactEmailInput, contactBodyText];
  inputs.forEach((input) => input?.addEventListener('blur', handleInputError));
}

if (loginButton) {
  console.log('LOGIN FORM');
  const inputs = [emailInput, passInput];
  inputs.forEach((input) => input?.addEventListener('blur', handleInputError));
}
